export interface Project {
    id: number;
    slug: string;
    title: string;
    location: string;
    city: string; // Added city field
    type: string;
    price: string;
    image: string;
    status: string;
    description?: string;
    specs?: {
        bedrooms: string;
        area: string;
        bathrooms?: string;
    };
    amenities?: string[];
}

export const projects: Project[] = [
    {
        id: 1,
        slug: "ireo-corridors",
        title: "IREO CORRIDORS",
        location: "Sector 67A, Golf Course Ext. Road",
        city: "Gurgaon",
        type: "Residential",
        price: "₹2.14 Cr onwards",
        image: "/IREO CORRIDORS.jpg",
        status: "Ready to Move",
        description: "Spread across 37.5 acres with only 20% used for buildings — major portion is green/open landscaping. Strategically located in Sector 67A, Ireo Corridors offers a holistic living experience with world-class amenities. Designed to integrate indoor and outdoor living, the apartments feature spacious balconies and large windows that offer panoramic views of the Aravallis.",
        specs: {
            bedrooms: "2, 3, 4 BHK",
            area: "1296 - 2740 sq ft",
            bathrooms: "2-4"
        },
        amenities: ['Swimming Pool', 'Clubhouse', 'Gymnasium', 'Tennis Court', 'Kids Play Area', '24/7 Security', 'Power Backup', 'Cafeteria', 'Jogging Track']
    },
    {
        id: 2,
        slug: "landmark-skyvue",
        title: "LANDMARK SKYVUE",
        location: "Sector 103, Dwarka Expressway",
        city: "Gurgaon",
        type: "Residential",
        price: "₹17,500/sq ft",
        image: "/Landmark skyvue.webp",
        status: "Ongoing",
        description: "Landmark Skyvue offers premium living spaces on the Dwarka Expressway. With modern architecture and thoughtful design, it provides an elevated lifestyle. Enjoy seamless connectivity to Delhi and key areas of Gurgaon.",
        specs: {
            bedrooms: "3, 4 BHK",
            area: "1800 - 2400 sq ft",
            bathrooms: "3-4"
        },
        amenities: ['Rooftop Pool', 'Luxury Club', 'Smart Home Features', 'Landscaped Gardens']
    },
    {
        id: 3,
        slug: "ireo-savannah",
        title: "IREO SAVANNAH",
        location: "Sector 35, Sohna",
        city: "Gurgaon",
        type: "Plotted Dev",
        price: "₹1.1 Lakh/sq yard",
        image: "/IREO SAVANNAH.webp",
        status: "New Launch",
        description: "Ireo Savannah brings you the opportunity to build your dream home in a secure, planned community. Located in the serene environment of Sohna, it offers large plots with dedicated green zones.",
        specs: {
            bedrooms: "Plots",
            area: "200 - 500 Sq Yards",
        },
        amenities: ['Gated Community', 'Wide Internal Roads', 'Street Lighting', 'Water Supply']
    },
    {
        id: 4,
        slug: "ireo-pride-park",
        title: "IREO PRIDE PARK",
        location: "Sector 4, Sohna",
        city: "Gurgaon",
        type: "Plotted Dev",
        price: "₹95.36 L - ₹1.66 Cr",
        image: "/Ireo-Pride-Park-Gurgaon.webp",
        status: "Ready to Move",
        description: "Ireo Pride Park is a premium plotted development nestled in the foothills of the Aravallis. It offers a perfect blend of nature and modern infrastructure, making it an ideal choice for a holiday home or permanent residence.",
        specs: {
            bedrooms: "Plots",
            area: "150 - 350 Sq Yards",
        },
        amenities: ['Clubhouse', 'Parks', 'Maintenance Staff', 'Security']
    },
    // Dehradun Projects
    {
        id: 5,
        slug: "pacific-golf-estate",
        title: "PACIFIC GOLF ESTATE",
        location: "Sahastradhara Road, Dehradun",
        city: "Dehradun",
        type: "Residential",
        price: "₹85 L onwards",
        image: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
        status: "Ready to Move",
        description: "Experience luxury living in the lap of nature at Pacific Golf Estate. Surrounded by lush greenery and offering breathtaking views of the Himalayas/Mussoorie hills, this project defines serenity and class.",
        specs: {
            bedrooms: "1, 2, 3 BHK",
            area: "800 - 2200 sq ft",
            bathrooms: "1-3"
        },
        amenities: ['Golf Course', 'Heated Pool', 'Spa', 'Meditation Center']
    },
    {
        id: 6,
        slug: "windlass-river-valley",
        title: "WINDLASS RIVER VALLEY",
        location: "NH-72, Haridwar Road, Dehradun",
        city: "Dehradun",
        type: "Township",
        price: "₹45 L onwards",
        image: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80", // Placeholder
        status: "Ongoing",
        description: "Windlass River Valley is a smart township designed for modern living. With extensive open spaces and top-notch facilities, it's a self-sufficient community perfect for families.",
        specs: {
            bedrooms: "2, 3 BHK",
            area: "1100 - 1800 sq ft",
            bathrooms: "2-3"
        },
        amenities: ['School', 'Hospital', 'Shopping Complex', 'Sports Club']
    },

    // Haridwar Projects
    {
        id: 7,
        slug: "hero-homes-haridwar",
        title: "HERO HOMES HARIDWAR",
        location: "Sidcul, Haridwar",
        city: "Haridwar",
        type: "Residential",
        price: "₹35 L onwards",
        image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80", // Placeholder
        status: "Ready to Move",
        description: "Located near the industrial hub and spiritual centers, Hero Homes Haridwar offers affordable yet premium housing options. Ideal for both investment and residential purposes.",
        specs: {
            bedrooms: "2, 3 BHK",
            area: "950 - 1500 sq ft",
            bathrooms: "2"
        },
        amenities: ['Community Hall', 'Temple', 'Green Parks', 'Yoga Area']
    },
    {
        id: 8,
        slug: "ambika-divine-park",
        title: "AMBIKA DIVINE PARK",
        location: "Near Patanjali Yogpeeth, Haridwar",
        city: "Haridwar",
        type: "Plotted Dev",
        price: "₹18,000/sq yard",
        image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80", // Updated valid landscape/plot image
        status: "New Launch",
        description: "Ambika Divine Park offers freehold residential plots in a spiritual and peaceful evironment. Close to Patanjali Yogpeeth and major highways.",
        specs: {
            bedrooms: "Plots",
            area: "100 - 300 Sq Yards",
        },
        amenities: ['Gated Colony', 'Wide Roads', 'Sewage System', 'Electric Pols']
    },

    // Exclusive Land Parcels
    {
        id: 9,
        slug: "vasundhara-land-parcel",
        title: "VASUNDHARA",
        location: "Vasundhara, Dehradun",
        city: "Dehradun",
        type: "Land Parcel",
        price: "₹90 Lakhs/Bigha",
        image: "/parcels/vasundhara.jpg",
        status: "Exclusive",
        description: "Prime land parcel in Vasundhara with verified clear titles and no legal encumbrances. Ideal for high-appreciation investment.",
        specs: {
            bedrooms: "Land",
            area: "50 Bighas",
        },
        amenities: ['Verified Clear Titles', 'No Legal Encumbrances', 'Prime Location', 'High Appreciation Potential']
    },
    {
        id: 10,
        slug: "adowala-land-parcel",
        title: "ADOWALA",
        location: "Adowala, Dehradun",
        city: "Dehradun",
        type: "Land Parcel",
        price: "₹85 Lakhs/Bigha",
        image: "/parcels/adowala.jpg",
        status: "Exclusive",
        description: "Exclusive land parcel in Adowala with verified clear titles and prime location advantages.",
        specs: {
            bedrooms: "Land",
            area: "30-50 Bighas",
        },
        amenities: ['Verified Clear Titles', 'No Legal Encumbrances', 'Prime Location', 'High Appreciation Potential']
    },
    {
        id: 11,
        slug: "yamunotri-highway-land-parcel",
        title: "YAMUNOTRI HIGHWAY",
        location: "Near Katapathar, Dehradun",
        city: "Dehradun",
        type: "Land Parcel",
        price: "₹80 Lakhs/Bigha",
        image: "/parcels/yamunotri.jpg",
        status: "Exclusive",
        description: "Strategic land parcel near Katapathar on Yamunotri Highway with excellent connectivity and growth potential.",
        specs: {
            bedrooms: "Land",
            area: "30 Bighas",
        },
        amenities: ['Verified Clear Titles', 'No Legal Encumbrances', 'Prime Location', 'High Appreciation Potential']
    },
    {
        id: 12,
        slug: "haridwar-ganga-kinare-land-parcel",
        title: "GANGA KINARE LAND PARCEL",
        location: "Ganga Kinare, Haridwar",
        city: "Haridwar",
        type: "Land Parcel",
        price: "₹1.5-2.5 Cr/Bigha",
        image: "/parcels/ganga-kinare.jpg",
        status: "Exclusive",
        description: "Premium riverside land parcel along the Ganga with unmatched spiritual and investment value.",
        specs: {
            bedrooms: "Land",
            area: "18-25 Bighas",
        },
        amenities: ['Verified Clear Titles', 'No Legal Encumbrances', 'Prime Location', 'High Appreciation Potential']
    },
    {
        id: 13,
        slug: "mussoorie-cloud-end-land-parcel",
        title: "MUSSOORIE CLOUD END",
        location: "Cloud End, Mussoorie",
        city: "Mussoorie",
        type: "Land Parcel",
        price: "₹50-95 Lakhs/Bigha",
        image: "/parcels/cloudend.jpeg",
        status: "Exclusive",
        description: "Scenic land parcel in Mussoorie's Cloud End area with breathtaking mountain views and excellent investment potential.",
        specs: {
            bedrooms: "Land",
            area: "30-60 Bighas",
        },
        amenities: ['Verified Clear Titles', 'No Legal Encumbrances', 'Prime Location', 'High Appreciation Potential']
    },
    {
        id: 14,
        slug: "jamnipur-land-parcel",
        title: "JAMNIPUR",
        location: "Jamnipur, Dehradun",
        city: "Dehradun",
        type: "Land Parcel",
        // Using a standard string for price to avoid encoding issues if possible, or just standard text
        price: "Price on Request",
        image: "/parcels/cloudend.jpeg",
        status: "Exclusive",
        description: "New exclusive land parcel in Jamnipur, Dehradun. Prime location with excellent connectivity.",
        specs: {
            bedrooms: "Land",
            area: "Available on Request",
        },
        amenities: ['Verified Clear Titles', 'Prime Location', 'Investment Potential']
    }
];
